import MyIndustryStar from './MyIndustryStar'
import * as actions from './my-industry-star-actions'
import saga from './my-industry-star-saga'

export {MyIndustryStar, actions, saga}
export default MyIndustryStar
